

import {
	Vector3,
	Euler,
    Matrix4
} from '../../../src/js/three.module.js';

import { getIntersectNormal } from '../../utils/intersections/utils.js';
import { ObjectClickHandler } from '../../utils/object-click-handler.js';
import { CommentsHandler }    from '../services/CommentsService.js';
import { DragHandle }         from "../services/DragHandlesService.js";


function buildPseudoIntersect( mesh ) {

    let _normal = (new Vector3(0, 0, 1)).applyQuaternion( mesh.quaternion );

    let ray_direction = _normal.negate();
    let ray_delta = ray_direction.clone().multiplyScalar( -0.1 );
    let ray_point = mesh.position.clone().add( ray_delta );

    let point = parseFirstIntersect.wall( getIntersects( ray_point, ray_direction )).point;

    const desiredNormal = _normal.clone();

    // Create a matrix that would transform faceNormal to desiredNormal
    const matrixWorld = new Matrix4();

    // You can use lookAt to create a rotation matrix
    // This creates a matrix that would rotate one vector to align with another
    const up = mesh.up; // or another suitable up vector
    matrixWorld.lookAt( new Vector3(0, 0, 0), desiredNormal, up );

    let normal = new Vector3(0,0,-1);

    return {
        point,
        object: { matrixWorld },
        face: { normal }
    };
}


export class Oeuvre {
    constructor(uid, w, h, d) {
        this.w = w;
        this.h = h;
        this.d = d;
        this.uid = uid;

        this.isSetted = false;

        this.isOeuvre = true;

        this.z_offset = 0;

        new ObjectClickHandler().attachTo(this);

        this.comments = new CommentsHandler(this);

        this.$commentMark = new DragHandle.Comment();
        this.$commentMark.isStatic = true;
        this.$commentMark.visible = false;

        this.$warnings = [];
    }
    setMesh(mesh) {
        this.mesh = mesh;

        this.mesh.visible = false;

        this.mesh.userData.type = "oeuvre";
        this.mesh.userData.oeuvre_uid = this.uid;
        this.mesh.userData.obj = this;

        this.mesh.add(this.$commentMark);

        this.$refreshUserData();
    }
    onChanged() {
        // Koska sijainti muuttuu, halutaan päivittää varjot (ja piirtää scene muutenkin)
        gameService.shadowsNeedsUpdate = true;
    }
    $refreshUserData() {
        var self = this;
        this.mesh.traverse(function (node) {

            if (typeof node.receiveShadow != "undefined")
                node.receiveShadow = true;

            node.userData = self.mesh.userData;
        });
    }
    setPlace(position, rotation, intersect) {
        position instanceof Vector3 && this.mesh.position.copy(position);
        rotation instanceof Euler && this.mesh.rotation.copy(rotation);

        this.mesh.visible = this.isSetted = true;

        walls && walls.refresh(this, intersect);
        walls && walls.clearEmpties();
        this.refreshHelpers();

        this.onChanged();
    }
    setPlaceByIntersect(intersect, fixed_bottom_offset) {
        if (!intersect) {
            if (this.$lastIntersect) {

                intersect = this.$lastIntersect;

            } else {
            
                var pseudoIntersect = { point: this.mesh.position.clone(), object: this.mesh, face: { normal: null /** @TODO */ } };

                if (this.shape == "3D") {
                    /** @TODO: Uudelleenkirjoita ja perustele? */
                    pseudoIntersect.face.normal = this.mesh.up.clone();
                    intersect = this.$lastIntersect = pseudoIntersect;
                } else {

                    try {
                        pseudoIntersect = buildPseudoIntersect( this.mesh );
                        intersect = this.$lastIntersect = pseudoIntersect;
                    } catch (error) {
                        console.error( error );
                    }

                    if (!intersect) {
                        return console.warn("Oeuvre.setPlaceByIntersect() :: Invalid Argument: Unable to set position. No intersect nor $lastIntersect");
                    }
                }
            }
        } else
            this.$lastIntersect = intersect;

        var normal = getIntersectNormal(intersect);

        if (normal.y <= -0.5) {
            if (!this.availPlanes.ceiling)
                return console.warn("Could not put obj on the roof"); //, window.Notification.error("Could not put this artwork on the roof"));
        } else if (normal.y < 0.5) {
            if (!this.availPlanes.wall)
                return console.warn("Could not put obj on the wall"); //, window.Notification.error("Could not put this artwork on the wall"));
        }
        else if (normal.y >= 0.5) {
            if (!this.availPlanes.floor)
                return console.warn("Could not put obj on the floor"); //, window.Notification.error("Could not put this artwork on the floor"));
        }

        var targetPoint;

        this.mesh.position.copy(intersect.point);

        this.z_offset = parseFloat(isNaN(this.z_offset) ? 0 : this.z_offset);

        if (this.shape == "3D") {
            if (normal.y < 0)
                return console.warn("3D Object cannot be on wall with normal with negative y"); //, window.Notification.error("Could not put 3D artwork here"))

            this.mesh.position.y += this.h / 2;
        } else {
            this.z_offset = Math.max(0, this.z_offset);

            if (fixed_bottom_offset) {
                helpers.refreshOeuvreBottomHelper(this);

                if (this.helper_bottomLine) {
                    var deltaY = -this.helper_bottomLine.length % fixed_bottom_offset;
                    this.mesh.translateY(deltaY);
                }
            }

            targetPoint = this.mesh.position.clone().add(normal);
        }
        

        if (this.z_offset != 0) {
            this.mesh.position.addScaledVector(normal, this.z_offset);
            if (targetPoint)
                targetPoint.addScaledVector(normal, this.z_offset);
        }

        if (targetPoint)
            this.mesh.lookAt(targetPoint);

        this.setPlace(null, null, intersect);

        return true;
    }
    setHeightFromBtmPlane() {
        /** @TODO: todo */
    }
    toggleVisibility() {
        this.setVisibility(!this.mesh.visible);
    }
    setVisibility(val) {
        var prev_visible = this.mesh.visible;

        if (this.mesh.visible = !!val) {
            actStack.addUndo("oeuvre.visibility.show", { oeuvre: this, prev_visible: prev_visible });
        } else {
            actStack.addUndo("oeuvre.visibility.hide", { oeuvre: this, prev_visible: prev_visible });
            this.refreshHelpers();
        }

        this.onChanged();
    }
    refreshHelpers() {
        if (this.isSetted) {
            helpers && helpers.refreshOeuvreHelper(this);
        } else {
            this.showHelpers(false);
        }

        this.onChanged();
    }
    showHelpers() { }
    setSize(v, val) {
        if (typeof val != "number")
            throw "Invalid argument";
        if (isNaN(val))
            throw "Invalid argument";

        switch (v) {
            case "h":
            case "height": v = "h"; break;

            case "w":
            case "width": v = "w"; break;

            case "d":
            case "depth": v = "d"; break;

            default: throw "Invalid argument";
        }

        if (this[v] == val)
            return;

        this[v] = val;

        this.height_cm = this.h * 100;
        this.width_cm = this.w * 100;
        this.depth_cm = this.d == null ? null : this.d * 100;

        this.onSizeChanged();
    }
    onSizeChanged() { }
}




